// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file.
//
// Read Sprockets README (https://github.com/sstephenson/sprockets#sprockets-directives) for details
// about supported directives.
//
const $ = require("jquery");
window.jQuery = $;
window.$ = $;

require("selectize");
require("jquery-ujs");
require("./libs/modernizr.min.js");
require("waypoints/lib/jquery.waypoints");

const ActiveStorage = require("@rails/activestorage");
ActiveStorage.start();
const Popin = require("home/popin");

// Global error handling // TODO move it somewhere else
// TODO these methods are called after other ajax:error (that are more specific) -- may want to find a way to call them before

$(function () {
  const error_popin = Popin($("#error-500-popin"));

  // 5xx Server Error
  $(document).ajaxError(function (event, xhr, status, error) {
    if (Math.floor(xhr.status / 100) == 5) {
      error_popin.show();
    }
  });
});

// 422 on CSRF error only (:unprocessable_entity)
$(document).ajaxError(function (event, xhr, status, error) {
  if (xhr.status == 422 && xhr.responseJSON && xhr.responseJSON.is_csrf_error) {
    console.log("Debug: CSRF error detected - reloading application");
    //event.stopImmediatePropagation(); // will stop all other handlers of this kind

    window.location = window.Anatec.constants.URLS.login;
  }
});

// 401 - not on requests from a sign_in json form (:unauthorized)
$(document).ajaxError(function (event, xhr, status, error) {
  if (
    xhr.status == 401 &&
    (!xhr.responseJSON ||
      (xhr.responseJSON && !xhr.responseJSON.is_auth_attempt))
  ) {
    console.log(
      "Debug: User is not connected and is not trying to json sign_in - reloading application",
    );

    window.location = window.Anatec.constants.URLS.login;
  }
});

// TODO CRITICAL 404

// 3xx Server Error
$(document).ajaxError(function (event, xhr, status, error) {
  if (Math.floor(xhr.status / 100) == 3) {
    console.log("Debug: Server sent redirect - doing nothing"); // TODO
  }
});

// connectivity problems // http://stackoverflow.com/questions/189430/detect-that-the-internet-connection-is-offlin
// TODO - NOTE: doesn't seems to be complete, when local server is off, inet::ERR_CONNECTION_REFUSED is thrown and not detected
$(document).ajaxError(function (event, xhr, status, error) {
  if (xhr.status == 0) {
    console.log(
      "Debug: There may be connectivity issues - status " +
        xhr.status +
        " - doing nothing",
    ); // TODO
  }
});
